var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCheckList24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6H13C13.55 6 14 6.45 14 7C14 7.55 13.55 8 13 8H3C2.45 8 2 7.55 2 7C2 6.45 2.45 6 3 6ZM3 10H13C13.55 10 14 10.45 14 11C14 11.55 13.55 12 13 12H3C2.45 12 2 11.55 2 11C2 10.45 2.45 10 3 10ZM3 16H9C9.55 16 10 15.55 10 15C10 14.45 9.55 14 9 14H3C2.45 14 2 14.45 2 15C2 15.55 2.45 16 3 16ZM22.3 12.3L22.21 12.21C21.82 11.82 21.18 11.82 20.8 12.22L16.02 17.01L13.72 14.71C13.33 14.32 12.7 14.32 12.31 14.71L12.22 14.8C11.83 15.19 11.83 15.82 12.22 16.21L15.31 19.3C15.7 19.69 16.33 19.69 16.72 19.3L22.3 13.71C22.69 13.32 22.69 12.69 22.3 12.3Z",
    fill: "#0033AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckList24Px);
export default __webpack_public_path__ + "static/media/ic_check-list_24px.5ed1fe014c9f08d9c0ad5766f6aa539a.svg";
export { ForwardRef as ReactComponent };